import imageOne from '@/assets/images/cities/fredericton1.jpg'
import imageTwo from '@/assets/images/cities/fredericton2.jpg'
import imageThree from '@/assets/images/cities/fredericton3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Fredericton',
  writeup: ``,
  website: 'FrederictonNotaryPublic.com',
  url: 'https://www.frederictonnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '',
      hours: {
        monday: '2:00PM to 5:00PM',
        tuesday: '2:00PM to 5:00PM',
        wednesday: '2:00PM to 5:00PM',
        thursday: '2:00PM to 5:00PM',
        friday: '2:00PM to 5:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: 'Westmorland Street Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/newBrunswick/cities/fredericton.js